import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import Config from '../../config';
import NavigationContext from '../../context/navigationContext';
import styles from './nav.css';

const Nav = ({ action, disable, setPosition }) => {
  const listRef = useRef(null);
  const { navLinks } = useContext(NavigationContext);
  const navLinkRefs = useRef([]);
  const topNav = [...navLinks, ...Config.links];

  const handleMouseEvents = event => {
    const el = listRef.current;

    if (el) {
      action(el.clientHeight, event.type);
    }
  };

  const updateHeight = () => {
    const el = listRef.current;

    if (el) {
      setPosition(el.firstChild.clientHeight, el.clientHeight);
    }
  };

  const componentLoaded = () => {
    updateHeight();
  };

  const setNavLinkThemes = () => {
    navLinks.map((link, index) => {
      const linkEl = navLinkRefs.current[index];
      const themeColors = link.themeColors;

      if (themeColors) {
        linkEl.style.setProperty('--nav-bg', themeColors['nav_bg_color']);
        linkEl.style.setProperty('--nav-hover-bg', themeColors['nav_bg_color_hover']);
        linkEl.style.setProperty('--nav-color', themeColors['nav_text_color']);
        linkEl.style.setProperty('--nav-hover-color', themeColors['nav_text_color_hover']);
      }
    });
  };

  useEffect(() => {
    updateHeight();
    setNavLinkThemes();

    if (window) {
      window.addEventListener('load', componentLoaded);
      window.addEventListener('resize', updateHeight);
    }

    return () => {
      if (window) {
        window.removeEventListener('load', componentLoaded);
        window.removeEventListener('resize', updateHeight);
      }
    };
  }, []);

  return (
    <nav
      onMouseEnter={disable ? undefined : handleMouseEvents}
      onMouseLeave={disable ? undefined : handleMouseEvents}
      className={styles.navBar}>
      <div ref={listRef} className={styles.list}>
        <NavLink
          exact
          className={`${styles.link} default`}
          activeClassName={styles.isActive}
          to="/">
          <span className={styles.linkText}>{`Upstatement Presents: The Art Direction Show`}</span>
        </NavLink>
        {topNav.map((item, index) => (
          <NavLink
            key={item.linkText}
            ref={linkRef => {
              navLinkRefs.current[index] = linkRef;
            }}
            className={`${styles.link} ${item.themeClass}`}
            activeClassName={styles.isActive}
            to={item.link}>
            <span className={styles.linkText}>{item.linkText}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

Nav.propTypes = {
  action: PropTypes.func,
  disable: PropTypes.bool,
  setPosition: PropTypes.func.isRequired,
  navLinks: PropTypes.array,
};

export default Nav;
